import React from 'react';
import { formatCurrency, formatDate } from '@ajaibid/utils';
import { Badge } from '@ajaibid/components';

import StockCodeLink from 'Component/StockCodeLink';

/**
 * @returns {import('@ajaibid/components').TableColumnDefinition[]}
 */
function useColumns() {
  const getTransactionType = (value) => (value === '1' && 'Buy') || (value === '2' && 'Sell') || '';

  const columns = [
    {
      path: 'trade_date',
      name: 'Waktu',
      renderCell: (ctx) => formatDate(ctx.getValue(), 'DD/MM/YY HH:mm'),
      size: 160,
    },
    {
      path: 'transaction_type',
      name: 'Aksi',
      renderCell: (ctx) => <Badge type="Order" orderVariant={getTransactionType(ctx.getValue())} />,
      size: 80,
    },
    {
      path: 'stock',
      name: 'Aset',
      renderCell: (ctx) => <StockCodeLink code={ctx.getValue()} />,
      size: 100,
    },
    {
      path: 'lot',
      name: 'Lot',
      size: 80,
    },
    {
      path: 'price_matched',
      name: 'Price',
      renderCell: (ctx) => formatCurrency(ctx.getValue(), 'IDR'),
      size: 160,
    },
    {
      path: 'total_price',
      name: 'Total',
      renderCell: (ctx) => formatCurrency(ctx.getValue(), 'IDR'),
      size: 160,
    },
    {
      name: 'Status',
      renderCell: () => 'Done',
      size: 160,
    },
  ];

  return columns;
}

export default useColumns;
